import React, { Component, FormEvent } from 'react';
import CustomAnimateButton from '../../../../custom/CustomAnimateButton';
import Icon from '../../../../../icons/Icon';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MessageUtil from '../../../../../util/MessageUtil';
import FormicaInput from 'components/custom/FormicaInput';
import RoleHelper from '../../../../../RoleHelper';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';
import AnimatedButton from '../../../../custom/AnimatedButton';

class ApiHeadersCreatorComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { parameter } = this.state;
    return (
      <div className={'flex w-full gap-x-4 items-center justify-start mb-5 px-1'}>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onKeyChange(e)}
            value={parameter.key}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
            data-testid={`${ComponentName.ACTION}_header_creator_key_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onValueChange(e)}
            value={parameter.value}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.value', defaultMessage: 'Value' })}
            data-testid={`${ComponentName.ACTION}_header_creator_value_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e) => this.onDescriptionChange(e)}
            value={parameter.description}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
            data-testid={`${ComponentName.ACTION}_header_creator_description_input`}
          />
        </div>
        <div className={''}>
          <AnimatedButton
            customType={'primary'}
            disabled={!RoleHelper.canEdit('Action')}
            onClick={this.handleSubmit}
            customSize={'sm'}
            icon={'add'}
            iconSize={18}
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            data-testid={`${ComponentName.ACTION}_header_creator_button`}

          />
        </div>
      </div>
    );
  }

  private onKeyChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, key: e.currentTarget.value } });
  };
  private onValueChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, value: e.currentTarget.value } });
  };
  private onDescriptionChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, description: e.currentTarget.value } });
  };
  private handleSubmit = () => {
    const { parameter } = this.state;
    const {
      action: { action },
      changeAction,
    } = this.props;
    if ((action as ApiActionJsonModel)?.headers != undefined && (action as ApiActionJsonModel)?.headers[parameter.key]) {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'messages.headerWithThisKeyAlreadyExist', defaultMessage: 'Header with this key already exist' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.cantAdded', defaultMessage: `${parameter.key} can't added` }, { 0: `${parameter.key}` })}</div>,
      });
      return false;
    }
    (action as ApiActionJsonModel).headers = { ...(action as ApiActionJsonModel).headers, [parameter.key]: parameter.value };
    changeAction(action);
    this.setState({ parameter: { ...this.state.parameter, key: '', value: '', description: '' } });
  };
}

interface Props extends ReduxProps, FormicaProps {}

interface Parameter {
  key: string;
  value: string;
  description: string;
}

class State {
  parameter: Parameter = {
    key: '',
    value: '',
    description: '',
  };
}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,

  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ApiHeadersCreatorComponent));
